export default function concatClasses(obj) {
  return Object.keys(obj).filter((i) => obj[i]).join(' ');
}
